// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================================================
 * StationChat — 스테이션 에이전트 채팅 화면
 * 자체 좁은 사이드바(52px) + 메인 영역. StationLayout 미사용.
 * ================================================================ */

.station-chat {
  display: flex;
  min-height: 100vh;
  background: var(--background);
  font-family: var(--font-sans);
  color: var(--fg-text-basic, var(--text-primary));
}

/* ─── 사이드바 (좁은 모드) ──────────────────────────────────── */
.station-chat__sidebar {
  flex-shrink: 0;
  width: 52px;
  background: var(--fg-bg-liteblue, #e8f4f9);
  border-right: 1px solid var(--fg-line, var(--border));
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: 12px 0;
  box-sizing: border-box;
}

.station-chat__sidebar--expanded {
  width: 260px;
  align-items: stretch;
  padding: 14px;
}

.station-chat__sidebar-top {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.station-chat__sidebar-bottom {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
}

.station-chat__sidebar-btn {
  position: relative;
  width: 32px;
  height: 32px;
  border: 0;
  background: transparent;
  border-radius: var(--radius-md, 6px);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-secondary);
}

.station-chat__sidebar-btn:hover {
  background: var(--fg-side-hover, rgba(0, 0, 0, 0.05));
  color: var(--text-primary);
}

.station-chat__sidebar-badge {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 14px;
  height: 14px;
  padding: 0 3px;
  border-radius: var(--radius-full, 9999px);
  background: var(--error, #e84545);
  color: #fff;
  font-size: 9px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}

.station-chat__sidebar-avatar {
  width: 32px;
  height: 32px;
  border-radius: var(--radius-full, 9999px);
  background: var(--gray-200);
  border: 0;
  color: var(--text-primary);
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
}

/* ─── 사이드바 확장 모드 추가 영역 ──────────────────────────── */
.station-chat__sidebar-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.station-chat__sidebar-brand {
  border: 0;
  background: transparent;
  cursor: pointer;
  color: var(--text-primary);
  padding: 0;
}

.station-chat__new-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 9px 12px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: var(--surface);
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
  cursor: pointer;
  margin-bottom: 16px;
}

.station-chat__new-btn:hover {
  background: var(--fg-bg-content);
}

.station-chat__sidebar-section-title {
  font-size: 11px;
  color: var(--text-tertiary, var(--text-secondary));
  font-weight: 600;
  padding: 0 4px 6px;
}

.station-chat__sidebar-list {
  flex: 1 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.station-chat__session {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;
  padding: 8px 10px;
  border: 0;
  background: transparent;
  border-radius: var(--radius-md);
  cursor: pointer;
  text-align: left;
}

.station-chat__session:hover {
  background: var(--fg-side-hover, rgba(0, 0, 0, 0.05));
}

.station-chat__session--active {
  background: var(--surface);
  box-shadow: var(--shadow-sm);
}

.station-chat__session-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
}

.station-chat__session-time {
  font-size: 11px;
  color: var(--text-tertiary, var(--text-secondary));
}

.station-chat__sidebar-foot {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.station-chat__sidebar-bell {
  position: relative;
  border: 0;
  background: transparent;
  width: 36px;
  height: 36px;
  border-radius: var(--radius-md);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-secondary);
}

.station-chat__sidebar-profile {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 8px 10px;
  border: 0;
  border-radius: var(--radius-md);
  background: transparent;
  cursor: pointer;
}

.station-chat__sidebar-profile:hover {
  background: var(--fg-side-hover, rgba(0, 0, 0, 0.05));
}

.station-chat__sidebar-profile-avatar {
  width: 30px;
  height: 30px;
  border-radius: var(--radius-full);
  background: var(--gray-200);
  color: var(--text-primary);
  font-weight: 700;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.station-chat__sidebar-profile-body {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.station-chat__sidebar-profile-name {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-primary);
}

.station-chat__sidebar-profile-email {
  font-size: 11px;
  color: var(--fg-link, var(--text-secondary));
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ─── 메인 ────────────────────────────────────────────────── */
.station-chat__main {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: var(--background);
}

.station-chat__header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 20px;
  border-bottom: 1px solid var(--border);
  background: var(--surface, #fff);
  height: 52px;
  box-sizing: border-box;
}

.station-chat__header-back {
  border: 0;
  background: transparent;
  width: 32px;
  height: 32px;
  border-radius: var(--radius-md);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-secondary);
}

.station-chat__header-back:hover {
  background: var(--fg-bg-content);
  color: var(--text-primary);
}

.station-chat__header-avatar {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.station-chat__header-title {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: var(--text-primary);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.station-chat__header-spacer {
  flex: 1 1;
}

.station-chat__header-action {
  border: 0;
  background: transparent;
  width: 32px;
  height: 32px;
  border-radius: var(--radius-md);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-secondary);
}

.station-chat__header-action:hover {
  background: var(--fg-bg-content);
  color: var(--text-primary);
}

.station-chat__header-profile {
  border: 0;
  background: transparent;
  padding: 0;
  cursor: pointer;
}

.station-chat__header-profile-avatar {
  width: 30px;
  height: 30px;
  border-radius: var(--radius-full);
  background: var(--gray-200);
  color: var(--text-primary);
  font-weight: 700;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

/* ─── 스크롤 영역 ─────────────────────────────────────────── */
.station-chat__scroll {
  flex: 1 1;
  overflow-y: auto;
  padding: 40px 24px 24px;
  display: flex;
  flex-direction: column;
}

/* 빈 상태 (환영 화면) */
.station-chat__welcome {
  margin: auto;
  width: 100%;
  max-width: 760px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 14px;
  padding: 40px 0;
}

.station-chat__welcome-avatar {
  margin-bottom: 6px;
}

.station-chat__welcome-title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  color: var(--text-primary);
}

.station-chat__welcome-desc {
  margin: 0;
  max-width: 600px;
  font-size: 13px;
  line-height: 1.6;
  color: var(--text-secondary);
}

.station-chat__starter {
  width: 100%;
  max-width: 760px;
  margin-top: 14px;
}

.station-chat__suggestions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px;
  margin-top: 4px;
}

.station-chat__suggestion {
  border: 1px solid var(--border);
  background: var(--surface);
  padding: 8px 14px;
  border-radius: var(--radius-full);
  font-size: 12px;
  color: var(--text-secondary);
  cursor: pointer;
  transition: border-color var(--transition-fast), color var(--transition-fast);
}

.station-chat__suggestion:hover {
  border-color: var(--fg-button, var(--primary-500));
  color: var(--fg-text-purple, var(--primary-700));
}

/* 메시지 영역 */
.station-chat__messages {
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.station-chat__msg {
  display: flex;
}

.station-chat__msg--user {
  justify-content: flex-end;
}

.station-chat__msg--assistant {
  justify-content: flex-start;
}

.station-chat__bubble {
  max-width: 80%;
  padding: 12px 16px;
  border-radius: var(--radius-2xl, 12px);
  font-size: 14px;
  line-height: 1.6;
}

.station-chat__bubble--user {
  background: var(--fg-button, var(--primary-500));
  color: #fff;
}

.station-chat__bubble--assistant {
  background: var(--surface);
  border: 1px solid var(--border);
  color: var(--text-primary);
}

.station-chat__bubble--assistant p {
  margin: 0 0 8px;
}

.station-chat__bubble--assistant p:last-child {
  margin-bottom: 0;
}

.station-chat__bubble--assistant h2 {
  font-size: 16px;
  margin: 4px 0 8px;
}

.station-chat__bubble--assistant ul,
.station-chat__bubble--assistant ol {
  margin: 4px 0 8px;
  padding-left: 20px;
}

.station-chat__bubble--assistant blockquote {
  margin: 8px 0;
  padding: 8px 14px;
  border-left: 3px solid var(--fg-button, var(--primary-500));
  background: var(--fg-bg-content);
  color: var(--text-secondary);
  border-radius: 0 var(--radius-md) var(--radius-md) 0;
}

.station-chat__bubble--assistant code {
  background: var(--fg-bg-content);
  padding: 2px 6px;
  border-radius: var(--radius-sm);
  font-size: 12px;
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
}

.station-chat__bubble--assistant table {
  border-collapse: collapse;
  margin: 8px 0;
  font-size: 12px;
}

.station-chat__bubble--assistant th,
.station-chat__bubble--assistant td {
  border: 1px solid var(--border);
  padding: 6px 10px;
}

.station-chat__bubble--assistant th {
  background: var(--fg-bg-content);
  font-weight: 700;
}

/* ─── 입력박스 ─────────────────────────────────────────── */
.station-chat__input-wrap {
  padding: 12px 24px 20px;
  background: var(--background);
}

.station-chat__input {
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  border: 1px solid var(--border);
  border-radius: var(--radius-full, 9999px);
  background: var(--surface);
  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);
}

.station-chat__input:focus-within {
  border-color: var(--fg-button, var(--primary-500));
  box-shadow: var(--focus-ring);
}

.station-chat__input-add,
.station-chat__input-send {
  border: 0;
  background: transparent;
  width: 32px;
  height: 32px;
  border-radius: var(--radius-full);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-secondary);
  flex-shrink: 0;
}

.station-chat__input-add:hover {
  background: var(--fg-bg-content);
  color: var(--text-primary);
}

.station-chat__input-send {
  background: var(--fg-button, var(--primary-500));
  color: #fff;
}

.station-chat__input-send:hover {
  background: var(--fg-button-hover, var(--primary-600));
}

.station-chat__input-send:disabled {
  background: var(--gray-200, #e5e7eb);
  color: var(--text-tertiary, var(--text-secondary));
  cursor: not-allowed;
}

.station-chat__input-field {
  flex: 1 1;
  border: 0;
  outline: none;
  background: transparent;
  font-size: 14px;
  font-family: inherit;
  color: var(--text-primary);
  padding: 4px 0;
}

.station-chat__input-field::placeholder {
  color: var(--text-tertiary, var(--text-secondary));
}
`, "",{"version":3,"sources":["webpack://./src/css/StationChat.css"],"names":[],"mappings":"AAAA;;;qEAGqE;;AAErE;EACE,aAAa;EACb,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,gDAAgD;AAClD;;AAEA,0DAA0D;AAC1D;EACE,cAAc;EACd,WAAW;EACX,0CAA0C;EAC1C,qDAAqD;EACrD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,qDAAqD;EACrD,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,eAAe;EACf,YAAY;EACZ,cAAc;EACd,yCAAyC;EACzC,iCAAiC;EACjC,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,2BAA2B;EAC3B,SAAS;EACT,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,kDAAkD;EAClD,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,SAAS;EACT,+BAA+B;EAC/B,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,4CAA4C;EAC5C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,8DAA8D;AAC9D;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;EACtC,gCAAgC;EAChC,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,2DAA2D;AAC3D;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;AACxB;;AAEA,iBAAiB;AACjB;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,iBAAiB;EACjB,iCAAiC;EACjC,eAAe;EACf,4BAA4B;EAC5B,eAAe;EACf,6EAA6E;AAC/E;;AAEA;EACE,kDAAkD;EAClD,gDAAgD;AAClD;;AAEA,WAAW;AACX;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,2DAA2D;EAC3D,gCAAgC;EAChC,4BAA4B;EAC5B,oDAAoD;AACtD;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;AACjB;;AAEA;;EAEE,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA,yDAAyD;AACzD;EACE,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,+BAA+B;EAC/B,yCAAyC;EACzC,0BAA0B;EAC1B,kFAAkF;AACpF;;AAEA;EACE,kDAAkD;EAClD,6BAA6B;AAC/B;;AAEA;;EAEE,SAAS;EACT,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,oCAAoC;EACpC,kDAAkD;EAClD,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,kDAAkD;AACpD","sourcesContent":["/* ================================================================\n * StationChat — 스테이션 에이전트 채팅 화면\n * 자체 좁은 사이드바(52px) + 메인 영역. StationLayout 미사용.\n * ================================================================ */\n\n.station-chat {\n  display: flex;\n  min-height: 100vh;\n  background: var(--background);\n  font-family: var(--font-sans);\n  color: var(--fg-text-basic, var(--text-primary));\n}\n\n/* ─── 사이드바 (좁은 모드) ──────────────────────────────────── */\n.station-chat__sidebar {\n  flex-shrink: 0;\n  width: 52px;\n  background: var(--fg-bg-liteblue, #e8f4f9);\n  border-right: 1px solid var(--fg-line, var(--border));\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 0;\n  box-sizing: border-box;\n}\n\n.station-chat__sidebar--expanded {\n  width: 260px;\n  align-items: stretch;\n  padding: 14px;\n}\n\n.station-chat__sidebar-top {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n}\n\n.station-chat__sidebar-bottom {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n}\n\n.station-chat__sidebar-btn {\n  position: relative;\n  width: 32px;\n  height: 32px;\n  border: 0;\n  background: transparent;\n  border-radius: var(--radius-md, 6px);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--text-secondary);\n}\n\n.station-chat__sidebar-btn:hover {\n  background: var(--fg-side-hover, rgba(0, 0, 0, 0.05));\n  color: var(--text-primary);\n}\n\n.station-chat__sidebar-badge {\n  position: absolute;\n  top: 0;\n  right: 0;\n  min-width: 14px;\n  height: 14px;\n  padding: 0 3px;\n  border-radius: var(--radius-full, 9999px);\n  background: var(--error, #e84545);\n  color: #fff;\n  font-size: 9px;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-sizing: border-box;\n}\n\n.station-chat__sidebar-avatar {\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-full, 9999px);\n  background: var(--gray-200);\n  border: 0;\n  color: var(--text-primary);\n  font-weight: 700;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n/* ─── 사이드바 확장 모드 추가 영역 ──────────────────────────── */\n.station-chat__sidebar-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 12px;\n}\n\n.station-chat__sidebar-brand {\n  border: 0;\n  background: transparent;\n  cursor: pointer;\n  color: var(--text-primary);\n  padding: 0;\n}\n\n.station-chat__new-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 100%;\n  padding: 9px 12px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-md);\n  background: var(--surface);\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n  cursor: pointer;\n  margin-bottom: 16px;\n}\n\n.station-chat__new-btn:hover {\n  background: var(--fg-bg-content);\n}\n\n.station-chat__sidebar-section-title {\n  font-size: 11px;\n  color: var(--text-tertiary, var(--text-secondary));\n  font-weight: 600;\n  padding: 0 4px 6px;\n}\n\n.station-chat__sidebar-list {\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.station-chat__session {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 2px;\n  padding: 8px 10px;\n  border: 0;\n  background: transparent;\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  text-align: left;\n}\n\n.station-chat__session:hover {\n  background: var(--fg-side-hover, rgba(0, 0, 0, 0.05));\n}\n\n.station-chat__session--active {\n  background: var(--surface);\n  box-shadow: var(--shadow-sm);\n}\n\n.station-chat__session-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n}\n\n.station-chat__session-time {\n  font-size: 11px;\n  color: var(--text-tertiary, var(--text-secondary));\n}\n\n.station-chat__sidebar-foot {\n  margin-top: 12px;\n  padding-top: 12px;\n  border-top: 1px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.station-chat__sidebar-bell {\n  position: relative;\n  border: 0;\n  background: transparent;\n  width: 36px;\n  height: 36px;\n  border-radius: var(--radius-md);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--text-secondary);\n}\n\n.station-chat__sidebar-profile {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  width: 100%;\n  padding: 8px 10px;\n  border: 0;\n  border-radius: var(--radius-md);\n  background: transparent;\n  cursor: pointer;\n}\n\n.station-chat__sidebar-profile:hover {\n  background: var(--fg-side-hover, rgba(0, 0, 0, 0.05));\n}\n\n.station-chat__sidebar-profile-avatar {\n  width: 30px;\n  height: 30px;\n  border-radius: var(--radius-full);\n  background: var(--gray-200);\n  color: var(--text-primary);\n  font-weight: 700;\n  font-size: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.station-chat__sidebar-profile-body {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n}\n\n.station-chat__sidebar-profile-name {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-primary);\n}\n\n.station-chat__sidebar-profile-email {\n  font-size: 11px;\n  color: var(--fg-link, var(--text-secondary));\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n/* ─── 메인 ────────────────────────────────────────────────── */\n.station-chat__main {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  background: var(--background);\n}\n\n.station-chat__header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 20px;\n  border-bottom: 1px solid var(--border);\n  background: var(--surface, #fff);\n  height: 52px;\n  box-sizing: border-box;\n}\n\n.station-chat__header-back {\n  border: 0;\n  background: transparent;\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-md);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--text-secondary);\n}\n\n.station-chat__header-back:hover {\n  background: var(--fg-bg-content);\n  color: var(--text-primary);\n}\n\n.station-chat__header-avatar {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.station-chat__header-title {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--text-primary);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.station-chat__header-spacer {\n  flex: 1;\n}\n\n.station-chat__header-action {\n  border: 0;\n  background: transparent;\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-md);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--text-secondary);\n}\n\n.station-chat__header-action:hover {\n  background: var(--fg-bg-content);\n  color: var(--text-primary);\n}\n\n.station-chat__header-profile {\n  border: 0;\n  background: transparent;\n  padding: 0;\n  cursor: pointer;\n}\n\n.station-chat__header-profile-avatar {\n  width: 30px;\n  height: 30px;\n  border-radius: var(--radius-full);\n  background: var(--gray-200);\n  color: var(--text-primary);\n  font-weight: 700;\n  font-size: 12px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* ─── 스크롤 영역 ─────────────────────────────────────────── */\n.station-chat__scroll {\n  flex: 1;\n  overflow-y: auto;\n  padding: 40px 24px 24px;\n  display: flex;\n  flex-direction: column;\n}\n\n/* 빈 상태 (환영 화면) */\n.station-chat__welcome {\n  margin: auto;\n  width: 100%;\n  max-width: 760px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 14px;\n  padding: 40px 0;\n}\n\n.station-chat__welcome-avatar {\n  margin-bottom: 6px;\n}\n\n.station-chat__welcome-title {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.station-chat__welcome-desc {\n  margin: 0;\n  max-width: 600px;\n  font-size: 13px;\n  line-height: 1.6;\n  color: var(--text-secondary);\n}\n\n.station-chat__starter {\n  width: 100%;\n  max-width: 760px;\n  margin-top: 14px;\n}\n\n.station-chat__suggestions {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 4px;\n}\n\n.station-chat__suggestion {\n  border: 1px solid var(--border);\n  background: var(--surface);\n  padding: 8px 14px;\n  border-radius: var(--radius-full);\n  font-size: 12px;\n  color: var(--text-secondary);\n  cursor: pointer;\n  transition: border-color var(--transition-fast), color var(--transition-fast);\n}\n\n.station-chat__suggestion:hover {\n  border-color: var(--fg-button, var(--primary-500));\n  color: var(--fg-text-purple, var(--primary-700));\n}\n\n/* 메시지 영역 */\n.station-chat__messages {\n  width: 100%;\n  max-width: 760px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.station-chat__msg {\n  display: flex;\n}\n\n.station-chat__msg--user {\n  justify-content: flex-end;\n}\n\n.station-chat__msg--assistant {\n  justify-content: flex-start;\n}\n\n.station-chat__bubble {\n  max-width: 80%;\n  padding: 12px 16px;\n  border-radius: var(--radius-2xl, 12px);\n  font-size: 14px;\n  line-height: 1.6;\n}\n\n.station-chat__bubble--user {\n  background: var(--fg-button, var(--primary-500));\n  color: #fff;\n}\n\n.station-chat__bubble--assistant {\n  background: var(--surface);\n  border: 1px solid var(--border);\n  color: var(--text-primary);\n}\n\n.station-chat__bubble--assistant p {\n  margin: 0 0 8px;\n}\n\n.station-chat__bubble--assistant p:last-child {\n  margin-bottom: 0;\n}\n\n.station-chat__bubble--assistant h2 {\n  font-size: 16px;\n  margin: 4px 0 8px;\n}\n\n.station-chat__bubble--assistant ul,\n.station-chat__bubble--assistant ol {\n  margin: 4px 0 8px;\n  padding-left: 20px;\n}\n\n.station-chat__bubble--assistant blockquote {\n  margin: 8px 0;\n  padding: 8px 14px;\n  border-left: 3px solid var(--fg-button, var(--primary-500));\n  background: var(--fg-bg-content);\n  color: var(--text-secondary);\n  border-radius: 0 var(--radius-md) var(--radius-md) 0;\n}\n\n.station-chat__bubble--assistant code {\n  background: var(--fg-bg-content);\n  padding: 2px 6px;\n  border-radius: var(--radius-sm);\n  font-size: 12px;\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n}\n\n.station-chat__bubble--assistant table {\n  border-collapse: collapse;\n  margin: 8px 0;\n  font-size: 12px;\n}\n\n.station-chat__bubble--assistant th,\n.station-chat__bubble--assistant td {\n  border: 1px solid var(--border);\n  padding: 6px 10px;\n}\n\n.station-chat__bubble--assistant th {\n  background: var(--fg-bg-content);\n  font-weight: 700;\n}\n\n/* ─── 입력박스 ─────────────────────────────────────────── */\n.station-chat__input-wrap {\n  padding: 12px 24px 20px;\n  background: var(--background);\n}\n\n.station-chat__input {\n  width: 100%;\n  max-width: 760px;\n  margin: 0 auto;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 10px;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-full, 9999px);\n  background: var(--surface);\n  transition: border-color var(--transition-fast), box-shadow var(--transition-fast);\n}\n\n.station-chat__input:focus-within {\n  border-color: var(--fg-button, var(--primary-500));\n  box-shadow: var(--focus-ring);\n}\n\n.station-chat__input-add,\n.station-chat__input-send {\n  border: 0;\n  background: transparent;\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-full);\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  color: var(--text-secondary);\n  flex-shrink: 0;\n}\n\n.station-chat__input-add:hover {\n  background: var(--fg-bg-content);\n  color: var(--text-primary);\n}\n\n.station-chat__input-send {\n  background: var(--fg-button, var(--primary-500));\n  color: #fff;\n}\n\n.station-chat__input-send:hover {\n  background: var(--fg-button-hover, var(--primary-600));\n}\n\n.station-chat__input-send:disabled {\n  background: var(--gray-200, #e5e7eb);\n  color: var(--text-tertiary, var(--text-secondary));\n  cursor: not-allowed;\n}\n\n.station-chat__input-field {\n  flex: 1;\n  border: 0;\n  outline: none;\n  background: transparent;\n  font-size: 14px;\n  font-family: inherit;\n  color: var(--text-primary);\n  padding: 4px 0;\n}\n\n.station-chat__input-field::placeholder {\n  color: var(--text-tertiary, var(--text-secondary));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
